import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import {DependencesService} from '../../../../services/dependences.service';

@Component({
  selector: 'ngx-municipal-legal-requirement',
  templateUrl: './municipal-legal-requirement.component.html',
  styleUrls: ['./municipal-legal-requirement.component.scss'],
})
export class MunicipalLegalRequirementComponent implements OnInit {

  @Input() stationId: string;
  @Input() dependenceId: string;

  requirement = {
    action: '',
    name: '',
    instrument: '',
    link: '',
    stage: '',
    type: 0,
    validity: '',
  };

  loading = false;

  constructor(
    protected ref: NbDialogRef<MunicipalLegalRequirementComponent>,
    private dependenciesService: DependencesService,
  ) { }

  ngOnInit() {}

  close() {
    this.ref.close(false);
  }

  async store() {
    this.loading = true;
    const data = { dependence_id: this.dependenceId, name: this.requirement.name, stage: this.requirement.stage, periodicity: this.requirement.validity }
    const [error] = await this.dependenciesService.createLegalRequirement(this.stationId, data);
    this.loading = false;
    if (error) return console.log(error);
    this.ref.close(true);
  }

}
